import React, { useState, useRef } from "react";
import { Tabs, Tab, Col, Row, Pagination, Button } from "react-bootstrap";
import SurveyBarChart from "./charts/SurveyBarChart";
import QuestionBarChart from "./charts/QuestionBarChart";
import { GetToken } from "../common/getToken";
import { useNavigate, useParams, Link } from "react-router-dom";
import QuestionModal from "./QuestionModal";
import AllQuestionsGrid from "./Grid/AllQuestionsGrid";
import { FaLongArrowAltLeft } from "react-icons/fa";
import GraphQuestionsGrid from "./Grid/GraphQuestionsGrid";
import SurveyAnalyticsTab from "./SurveyAnalyticsTab";
import QuestionAnalyticsTab from "./QuestionAnalyticsTab";
import axios from "axios";
import Swal from "sweetalert2";
import { useEffect } from "react";
import moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const ChartTabs = ({ overview, surveyDetails, BASE_URL, surveyId }) => {
  const { REACT_APP_BASE_URL } = process.env;
  const { REACT_APP_API_URL } = process.env;

  /* variable declarations */
  pdfMake.vfs = pdfFonts.vfs;
  let history = useNavigate();
  const childRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [questionId, setQuestionId] = useState();
  const [questionText, setQuestionText] = useState();
  const [popupdata, setpopupdata] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTabSecond, setLoadingTabSecond] = useState(true);
  const [nodata, setNodata] = useState(false);
  const [detailGraph, setDetailGraph] = useState([]);
  const [activeTab, setActiveTab] = useState("surveyAnalytics");
  const [activePage, setActivePage] = useState(() => 1);
  const [PageNumberCount, setPageNumberCount] = useState(() => 1);
  const [limit, setLimit] = useState(() => 1);
  const [answerTypeId, setAnswerTypeId] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [sortBy, setSortBy] = useState();
  const [totalQuestions, setTotalQuestions] = useState();
  const [overviewData, setOverviewData] = useState([]);
  const [filterButton, setFilterButton] = useState("side");

  let items = [];
  let questions = "Total Questions:";
  let response = "Total Responses:";
  let surveyees = "Total Respondents:";

  for (let number = 1; number <= Math.ceil(totalQuestions / 5); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePage}
        onClick={() => setLimit(number)}
      >
        {number}
      </Pagination.Item>,
    );
  }

  useEffect(() => {
    // getSurveyAnalytics(surveyId);
  }, [
    allQuestions,
    history,
    surveyId,
    limit,
    answerTypeId,
    startDate,
    endDate,
    sortBy,
  ]);

  useEffect(() => {
    if (activePage === 1) {
      setPageNumberCount(activePage);
    } else {
      let a = 0;
      for (let i = 1; i < activePage; i++) {
        a = a + 5;
      }
      setPageNumberCount(a + 1);
    }
  }, [activePage]);

  const changeFilterBox = async () => {
    if (filterButton == "hide") {
      setFilterButton("show");
    } else {
      setFilterButton("hide");
    }
  };

  return (
    <>
      <Row className="g-3 mb-2 mt-2 mb-md-3 mt-md-3 row row-cols-1 row-cols-md-3">
        <Col>
          <div className="card rounded-0 shadow p-3 d-flex align-items-center flex-row justify-content-between">
            <b>{surveyees}</b>
            {surveyDetails.uniqueUsers}
          </div>
        </Col>
        <Col>
          <div className="card rounded-0 shadow p-3 d-flex align-items-center flex-row justify-content-between">
            <b>{questions} </b>
            {surveyDetails.totalQuestions}
          </div>
        </Col>
        <Col>
          <div className="card rounded-0 shadow p-3 d-flex align-items-center flex-row justify-content-between">
            <b>{response}</b>
            {surveyDetails.totalquestionResponses}
          </div>
        </Col>
      </Row>
      <center
        style={{ paddingTop: "25vh" }}
        className={loading ? "" : "d-none"}
      >
        <br />
        <h4>Loading...</h4>
      </center>

      <span className={!loading ? "" : "d-none"}>
        {surveyDetails.uniqueUsers > 0 ? (
          <Row>
            <Col lg={12}>
              <div className="chart-separation mt-4">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={activeTab}
                  onSelect={(t) => {
                    setActiveTab(t);
                  }}
                  className="border-0"
                >
                  <Tab eventKey="surveyAnalytics" title="Overview">
                    <SurveyAnalyticsTab
                      surveyId={surveyId}
                      surveyDetails={surveyDetails}
                    />
                  </Tab>
                  {/* -=- TAB 2 =-= */}
                  <Tab
                    eventKey="questionAnalytics"
                    //  onEntered={() => getQuestionAnalytics(surveyId)}
                    title="Question Analytics"
                  >
                    <QuestionAnalyticsTab
                      surveyId={surveyId}
                      surveyDetails={surveyDetails}
                    />
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col lg={12} className="text-center">
              <div className="py-5">
                <h5 className="text-danger">
                  No Respondents found for this survey
                </h5>
              </div>
            </Col>
          </Row>
        )}
      </span>

      <QuestionModal
        show={modalShow}
        questionNo={questionId}
        QuestionText={questionText}
        popupdata={popupdata}
        surveyDetails={surveyDetails}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default ChartTabs;
